var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currency !== _vm.defaultCurrency)?_c('div',[_vm._v(" "+_vm._s(_vm.$t('views.showcase_checkout.conversion_note', {currency_from: _vm.currency, currency_to: _vm.defaultCurrency, price: _vm.price}))+". ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }